import _ from "lodash";
import { Modal, notification, Select } from "antd";
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

import { InboxOutlined } from "@ant-design/icons";

import { Form, Input, Button, Radio, Upload, message } from "antd";
import { useGlobalStore } from "../../../../stores/globalBackendStore";
import parseMediaUrl from "../../functions/parseMediaUrl";
import {
  getGlobalMatchdays,
  uploadMedia,
} from "../../../../services/backend/api.service";
import { useTranslation } from "react-i18next";
import { Preview } from "./Preview";
import Images from "./Images";

const { Dragger } = Upload;

const validateMessages = {
  required: "'${name}' is required!",
  // ...
};

export default (props) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const apiSetup = useGlobalStore((state) => state.apiSetup);
  const {
    id,
    visibleEdit,
    setVisibleEdit,
    editData,
    setEditData,
    setRefreshData,
    onPlayerItemChange,
    onNew,
  } = props;

  const [confirmLoading, setConfirmLoading] = useState(false);
  const [visibleMedia, setVisibleMedia] = useState(false);
  const [newTeamLogo, setNewTeamLogo] = useState(null);
  const onValuesChange = (value) => {
    const { uuid } = editData;
    if (onPlayerItemChange) {
      onPlayerItemChange({
        uuid: uuid,
        changed: value,
      });
    }
  };

  const onFinish = async (values) => {
    setConfirmLoading(false);
    setVisibleEdit(false);
    setRefreshData(true);
  };

  const onSave = (data) => {
    setConfirmLoading(true);
    form.submit();
    if (onNew) {
      const formValues = form.getFieldsValue();
      const newPlayer = {
        player: formValues?.player,
        age: formValues?.age,
        marketValue: formValues?.marketValue,
        team: {
          id: "logo",
          label: "Team Logo",
          type: "media",
          dragResize: true,
          allowedActions: ["resize", "move"],
          allowedMediaTypes: ["image"],
          value: newTeamLogo,
        },
        uuid: uuidv4(),
      };
      onNew(newPlayer);
    }
  };

  useEffect(() => {
    if (editData && editData.url) {
      form.setFieldsValue({
        label: editData.label,
      });
    }
  }, [editData]);

  const slideFields = [
    {
      label: "Name",
      name: "player",
      type: "text",
      value: "",
    },
    {
      label: "Age",
      name: "age",
      type: "text",
      value: "",
    },
    {
      label: "Market Value",
      name: "marketValue",
      type: "text",
      value: "",
    },
  ];
  //use label, when data is empty
  const getInitialValues = () => {
    const values = slideFields.map((field) => {
      return {
        [field.name]: field.value,
      };
    });
    const valuesObj = {};
    for (const value of values) {
      const keys = Object.keys(value);
      const key = keys[0];
      if (editData[key]) {
        valuesObj[key] = editData[key];
      } else {
        valuesObj[key] = value[key];
      }
    }
    return valuesObj;
  };

  return (
    <Modal
      title="Player edit"
      style={{ top: 20 }}
      open={visibleEdit}
      okText={"Save"}
      confirmLoading={confirmLoading}
      onOk={() => {
        onSave();
      }}
      onCancel={() => {
        setEditData({
          uuid: "0",
        });
        setVisibleEdit(false);
      }}
      maskClosable={false}
      width={1800}
      height={700}
      className={"player-edit-form"}
    >
      <div className="player-edit-container">
        <div className="player-edit-left-container">
          <Images
            group={"_default"}
            onUploadNew={(data) => {}}
            onSelect={(e, data) => {
              if (onPlayerItemChange) {
                const { uuid, team } = editData;
                onPlayerItemChange({
                  uuid: uuid,
                  changed: {
                    team: {
                      ...team,
                      value: data,
                    },
                  },
                });
              } else {
                console.log("on save on new", data);
                setNewTeamLogo(data);
              }
            }}
            initialActiveGroup={"0"}
            visibleEdit={false}
            setVisibleEdit={setVisibleEdit}
            editData={editData}
            setEditData={setEditData}
          />
        </div>
        <Form
          validateMessages={validateMessages}
          layout={"horizontal"}
          form={form}
          initialValues={getInitialValues()}
          onValuesChange={onValuesChange}
          onFinish={onFinish}
        >
          <Form.Item hidden={true} key={"files"} name={"files"} rules={[]}>
            <Input />
          </Form.Item>

          {_.map(slideFields, (item, key) => {
            return (
              <Form.Item
                key={item.name}
                label={item.label}
                name={item.name}
                rules={[]}
              >
                <Input placeholder={item.label} />
              </Form.Item>
            );
          })}
        </Form>
      </div>
    </Modal>
  );
};
